import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { AssumedWrapCashHoldings } from "../../../../Common/PaymentsIn/AssumedWrapCashHoldings";
import { RegularPayment } from "../../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { TransferIn } from "../../../../Common/PaymentsIn/TransferIn/TransferIn";
import { PaymentType, processTypeEnum } from "../../../../Common/Resource/Contents";
import { nbPaymentsInMessages } from "../../../../NewBusinessWizard/Resource/Contents";

interface IPaymentsInProps extends IProcessComponentProps {}

interface IPaymentsInState {}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    public isValid(): boolean {
        let isValid = super.isValid();
        isValid = isValid && this.atLeastOneContribution();
        if (!this.atLeastOneContribution()) {
            this.props.showErrorMsgPopUp([nbPaymentsInMessages.atLeastOneContribution]);
        }
        return isValid;
    }

    private atLeastOneContribution(): boolean {
        const { data } = this.props;

        return (
            data.GiaQuote?.ClientSinglePayment?.Money?.Amount > 0 ||
            data.GiaQuote?.ThirdPartySinglePayment?.Money?.Amount > 0 ||
            data.GiaQuote?.ClientRegularPayment?.Money?.Amount > 0 ||
            data.GiaQuote?.ThirdPartyRegularPayment?.Money?.Amount > 0 ||
            data.GiaQuote?.GiaTransfers?.length > 0
        );
    }

    public render(): JSX.Element {
        const { onChange, data } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("GiaQuote")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.InvestmentAccount}
                    hasPaymentMethod={false}
                    processType={processTypeEnum.Quote}
                />
                <hr />
                <RegularPayment
                    {...this.getProps("GiaQuote")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.InvestmentAccount}
                    hasContinue={true}
                    hasIndexation={false}
                    processType={processTypeEnum.Quote}
                />
                <hr />
                <TransferIn
                    isPost={false}
                    data={this.props.data?.GiaQuote?.GiaTransfers}
                    subAccountType={SubAccountType.InvestmentAccount}
                    jouneryType={processTypeEnum.Quote}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "GiaQuote"),
                            changes,
                            data.PensionQuote
                        )
                    }
                    isReview={this.props.isReview}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onRef={(ref) => this.appendChild(ref)}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                />

                <hr />
                {!data.SelectedProducts.some((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)) &&
                    !data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa) && (
                        <AssumedWrapCashHoldings {...this.getProps("AssumedHoldings")} />
                    )}
            </div>
        );
    }
}
